// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
import {
  MembershipRulesDefinition,
  MembershipScope,
} from '@/membership/api/membership-types';

/** The scope of the definition's single selection. */
export function toScope(
  definition: MembershipRulesDefinition
): MembershipScope {
  return (
    definition.selections[0]?.scope ?? {
      items: { isAll: false, keys: [] },
      joinRules: [],
      leaveRules: [],
    }
  );
}

/** Swaps the definition's single scope for a new one. */
export function toDefinitionWithScope(
  definition: MembershipRulesDefinition,
  scope: MembershipScope
): MembershipRulesDefinition {
  return {
    ...definition,
    selections: definition.selections.map((selection, index) =>
      index === 0 ? { ...selection, scope } : selection
    ),
  };
}
